import {Component, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';
import {Loader} from '../../models/loader/loader.redux';
import {ActivatedRoute, Params} from '@angular/router';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {IUser} from '../../models/auth';
import {StorageService} from '../../services/storage/storage.service';
import {ServiceAction, ServiceState} from '../../models/service';
import {cloneDeep} from 'lodash';
import {firstValueFrom} from 'rxjs';
import {MeasurementAction} from '../../models/measurement';

export interface IComplexFormula {
  idealHigh: number;
  idealLow: number;
  idealPercentileHigh: string;
  idealPercentileLow: string;
  realHigh: number;
  realLow: number;
  realPercentileHigh: string;
  realPercentileLow: string;
}

@Component({
  selector: 'app-consultation-diagnosis',
  templateUrl: './consultation-diagnosis.component.html',
  styleUrls: ['./consultation-diagnosis.component.scss'],
})
export class ConsultationDiagnosisComponent implements OnInit {
  expertId: string;
  clinicId: string;
  patientId: string;
  serviceId: string;
  appointmentId: string;
  constructor(
    private store: Store,
    private utilitiesService: UtilitiesService,
    private activatedRoute: ActivatedRoute,
    private messageAlertService: MessageAlertService,
    private storageService: StorageService
  ) {

  }

  async ngOnInit(): Promise<void> {
    await this.setRouterParams();
    await this.initValuesHttp();
  }

  /**
   * Obtiene los valores iniciales.
   */
  async initValuesHttp(): Promise<void> {
    await firstValueFrom((this.store.dispatch(new Loader(true, 'Obteniendo información ...'))));
    try {
      await firstValueFrom(this.store.dispatch(
        new MeasurementAction.GetAvailableFormulas(
          this.serviceId,
          this.patientId,
          this.expertId
        )));
    } catch (e) {
      console.error('[ConsultationDiagnosisComponent] ', e);
    } finally {
      await firstValueFrom((this.store.dispatch(new Loader(false))));

    }
  }


  /**
   * Setea los parametros de la url.
   */
  async setRouterParams(): Promise<void> {
    const params: Params = this.utilitiesService.getAllParams(this.activatedRoute);
    this.clinicId = params.clinicId;
    this.patientId = params.patientId;
    const userLogged = this.storageService.getLocalItem<{
      user: IUser;
      token: string;
    }>('user')?.user;
    if (userLogged && userLogged.experts) {
      this.expertId = userLogged.experts[0]._id;
    }
    this.serviceId = cloneDeep(await firstValueFrom((this.store.selectOnce(ServiceState.getServiceSelectedId))));
    if (!this.serviceId) {
      await firstValueFrom((this.store.dispatch(new ServiceAction.GetActive(this.patientId, this.expertId))));
      this.serviceId = cloneDeep(await firstValueFrom((this.store.selectOnce(ServiceState.getServiceSelectedId))));
    }
    this.activatedRoute.queryParams.subscribe((value) => {
      this.appointmentId = value.appointmentId;
      if (value.expert) {
        this.expertId = value.expert;
      }
    });
  }
}
